import script from "./SearchModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchModal.vue?vue&type=script&setup=true&lang=js"

import "./SearchModal.vue?vue&type=style&index=0&id=2eaa6ce8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2eaa6ce8"]])

export default __exports__